<template>
    <el-dialog :title="dialogName" :visible.sync="dialogVisible" width="90%" :close-on-click-modal="false" :modal-append-to-body="true">
      <div class="main-box">
        <el-form ref="dataForm" id="dataForm" :model="temp" :rules="rules" label-width="160px" label-suffix="：">

          <el-card class="box-card form-card" style="margin-top: 10px; position: relative;">
            <el-row :gutter="15">
              <el-col :span="6">
                <el-form-item  label="身份证号">
                  <el-input  v-model="identityCardNo" placeholder="请输入18位身份证号" style="width: 100%"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="4">
                <div class="formItemDiv">
                  <div class="th-button" @click="search" style="text-align: center;"><i class="wk wk-search"/><span>查询</span></div>
                  <div class="th-button" type="success"  @click="printTag" v-if="isPrintShow" style="text-align: center;"><i class="wk wk-generate-report"/><span>打印</span></div>
                </div>
              </el-col>
            </el-row>

            <div @click="downloadPrint" style="text-decoration: none; color: #007aff; position: absolute; right: 40px; top: 33px; cursor: pointer;">打印插件下载</div>

          </el-card>


          <el-card class="box-card form-card" style="margin-top: 10px;">
            <el-row :gutter="15">
              <el-col :span="12">
                <el-form-item label="姓名">{{temp.SICK_NAME || '-' }}</el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="年龄">{{temp.SICK_AGE || '-' }}</el-form-item>
              </el-col>
              <el-col :span="24">
                <el-form-item label="机构">{{temp.ORG_COMPLETE_NAME || '-' }}</el-form-item>
              </el-col>
              <el-col :span="24">
                <el-form-item label="家庭医生">{{temp.MANAGE_STAFF_NAME || '-' }}</el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="目前签约状态">{{temp.IS_SIGN || '-' }}</el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="签约机构">{{temp.SIGN_ORG || '-' }}</el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="签约开始日期">{{temp.SIGN_START_TIME || '-' }}</el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="签约结束日期">{{temp.SIGN_END_TIME || '-' }}</el-form-item>
              </el-col>
              <el-col :span="24">
                <el-form-item label="高血压">{{temp.BLOOD_CONTENT1 || '-' }}</el-form-item>
              </el-col>
              <el-col :span="24">
                <el-form-item label="糖尿病">{{temp.GLUCOSE_CONTENT1 || '-' }}</el-form-item>
              </el-col>
              <el-col :span="24">
                <el-form-item label="年度年检情况">{{temp.MEDICAL_CONTENT || '-' }}</el-form-item>
              </el-col>
            </el-row>
          </el-card>
        </el-form>
      </div>
      <div slot="footer" class="dialog-footer">
        <xr-button type="default" @click.native="dialogVisible = false">关闭</xr-button>
      </div>
    </el-dialog>

</template>

<script>

  import {getLodop} from "../../utils/lodop/LodopFuncs";


    export default {
        name: "CompanyInfo",
        data() {
          return {
            dialogName: '公卫信息查询',
            dialogVisible: false,                                        //弹框
            identityCardNo: '',
            isPrintShow: false,
            printContent: '',
            temp: {
              DATE_TIME :'',              //当前时间
              SICK_NAME :'',              //姓名
              SICK_AGE :'',               //年龄
              ORG_COMPLETE_NAME :'',       //机构
              MANAGE_STAFF_NAME: '',      //管理医生
              IS_SIGN: '',                //目前签约状态
              SIGN_ORG: '',               //签约机构
              SIGN_START_TIME: '',        //签约开始日期
              SIGN_END_TIME: '',          //签约结束日期
              BLOOD_CONTENT: '',          //高血压
              BLOOD_CONTENT1: '',          //高血压
              GLUCOSE_CONTENT: '',        //高血压
              GLUCOSE_CONTENT1: '',        //糖尿病
              MEDICAL_CONTENT: '',        //体检内容


            },
            rules: []
          }
        },
        components: {

        },
        methods: {
          init(){
            this.dialogVisible = true;
          },
          search(){
            let identityCardNo = this.identityCardNo;
            if(!this.validateIdCard(identityCardNo)){
              this.$message.error('身份证号码格式不正确或校验失败！');
              return false;
            }

            return this.request({
              method:'post',
              url:'/register/getSickIsSign',
              params:{
                'cardNo': identityCardNo
              }
            }).then((response) =>{          //这里使用了ES6的语法
              // 请求成功返回的数据
              //如果返回编码不为0，提示失败语
              if(response.code != '0'){
                this.$message.error(response.msg);
                return false;
              }

              if(!!response.data.dataStream){
                this.isPrintShow = true;
                this.printContent = response.data.dataStream;
              }

              if(!!response.data){
                this.temp = response.data;
              }

            })
          },
          //打印标签
          printTag(){
            let LODOP = getLodop();
            LODOP.PRINT_INIT("打印URL地址内容");
            LODOP.SET_PRINT_PAGESIZE(1,"80mm","180mm");
            // 添加数据表格
            LODOP.ADD_PRINT_TABLE(0, 0, "100%",1, this.printContent);
            LODOP.PREVIEW();

          },
          //下载打印插件
          downloadPrint(){
            window.location.href = process.env.BASE_URL+"/static/exe/CLodop_Setup_for_Win32NT.exe";
          },
          //验证身份证号
          validateIdCard(id) {
            // 去除空格
            id = id.trim()
            // 初步格式校验（18位，最后一位可能是X）
            const reg = /^[1-9]\d{5}(18|19|20)\d{2}((0[1-9])|(1[0-2]))((0[1-9])|([1-2]\d)|(3[0-1]))\d{3}[\dXx]$/
            if (!reg.test(id)) {
              return false
            }

            // 校验码验证（仅适用于18位）
            const weights = [7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2]
            const checkCodes = ['1', '0', 'X', '9', '8', '7', '6', '5', '4', '3', '2']

            let sum = 0
            for (let i = 0; i < 17; i++) {
              sum += parseInt(id[i], 10) * weights[i]
            }
            const mod = sum % 11
            const expectedCheckCode = checkCodes[mod]
            return id[17].toUpperCase() === expectedCheckCode
          }
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/header/PhSearch.vue